import { motion } from "framer-motion";
import { MessageCircle, CalendarDays } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const WHATSAPP_URL = "https://wa.me/33660235665";
const CALENDLY_URL = "https://calendar.app.google/C866HmTsf8RckhiE9";

export const FinalCTA = () => {
  const { t } = useLanguage();
  return (
    <section id="cta" className="bg-[#FFE440] border-y-2 border-black py-16 lg:py-20" data-testid="final-cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center justify-between gap-8">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <h2 className="font-['Cutive'] text-3xl sm:text-4xl font-bold mb-3">{t.finalCta.title}</h2>
          <p className="font-['Ubuntu'] text-black/80 max-w-md">{t.finalCta.subtitle}</p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="flex flex-wrap gap-4"
        >
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp-final"
            className="inline-flex items-center gap-2 bg-black text-white font-['Ubuntu'] font-bold rounded-full px-6 py-3.5 border-2 border-black hover:bg-white hover:text-black transition-colors"
          >
            <MessageCircle className="w-4 h-4" /> {t.finalCta.whatsapp}
          </a>
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-calendly-final"
            className="inline-flex items-center gap-2 bg-white text-black font-['Ubuntu'] font-bold rounded-full px-6 py-3.5 border-2 border-black hover:bg-black hover:text-white transition-colors"
          >
            <CalendarDays className="w-4 h-4" /> {t.finalCta.schedule}
          </a>
        </motion.div>
      </div>
    </section>
  );
};
